package com.vamvisions.main.portfolio.presentation.common

import com.vamvisions.main.core.presentation.i18n.Strings
import com.vamvisions.main.portfolio.domain.model.PartialDate

/**
 * Formats periods such as "Jun 2022 – Sep 2025" or "2018 – now". Short month names come from [Strings], so the
 * output doesn't depend on the browser locale.
 */
object PeriodFormatter {

    fun format(start: PartialDate, end: PartialDate?, strings: Strings): String =
        "${format(start, strings)} – ${end?.let { format(it, strings) } ?: strings.present}"

    fun format(date: PartialDate, strings: Strings): String =
        date.month?.let { month -> "${strings.shortMonthNames[month - 1]} ${date.year}" } ?: date.year.toString()
}
